<template>
    <div class="roles">
        <Registration/>
    </div>
</template>

<script>
import Registration from '@/components/Registration.vue'
export default {
    name: 'roles',
    components: {
        Registration
    }
}
</script>